export default __webpack_public_path__ + "static/media/logo.01bc4c3a.svg";